export var REPRINT_SCOPE_OPTIONS = [
    { label: 'Whole Population', value: 'whole_population' },
    { label: 'Specific Groups Only', value: 'specific_groups_only' }
];
export var ACTION_TYPE_OPTIONS = [
    { label: 'Add', value: 'add' },
    { label: 'Delete', value: 'delete' }
];
export var HIERARCHY_UPDATE_OPTIONS = [
    { label: 'Yes', value: 'yes' },
    { label: 'No', value: 'no' }
];
// Attachment type options for Plan Change Handling
var PlanChangeAttachmentTypeEnum;
(function (PlanChangeAttachmentTypeEnum) {
    PlanChangeAttachmentTypeEnum["PlanDocuments"] = "Plan Documents";
    PlanChangeAttachmentTypeEnum["AdcCodeInformation"] = "ADC Code Information";
    PlanChangeAttachmentTypeEnum["GroupStructureUpdates"] = "Group Structure Updates";
})(PlanChangeAttachmentTypeEnum || (PlanChangeAttachmentTypeEnum = {}));
export var ACCUMULATOR_CHANGE_ATTACHMENT_OPTIONS = [
    { label: 'Plan Documents', value: PlanChangeAttachmentTypeEnum.PlanDocuments }
];
export var FERTILITY_MAXIMUM_ATTACHMENT_OPTIONS = [
    {
        label: 'ADC Code Information',
        value: PlanChangeAttachmentTypeEnum.AdcCodeInformation
    }
];
export var GROUP_NUMBER_CHANGE_ATTACHMENT_OPTIONS = [
    {
        label: 'Group Structure Updates',
        value: PlanChangeAttachmentTypeEnum.GroupStructureUpdates
    }
];
export var PLAN_CHANGE_HANDLING_ATTACHMENT_OPTIONS = [
    {
        label: 'Plan Documents',
        value: PlanChangeAttachmentTypeEnum.PlanDocuments
    },
    {
        label: 'ADC Code Information',
        value: PlanChangeAttachmentTypeEnum.AdcCodeInformation
    },
    {
        label: 'Group Structure Updates',
        value: PlanChangeAttachmentTypeEnum.GroupStructureUpdates
    }
];
